import React from 'react';
import { Fieldset } from 'react-redux-form';
import Input from 'components/Fields/Input';
import TextArea from 'components/Fields/TextArea';
import SmoothLinkTarget from 'components/SmoothLink/Target';

const FormMain = () => (
  <Fieldset model=".properties">
    <SmoothLinkTarget
      name="userrequest.properties.title"
    >
      <Input
        model=".title"
        label="Nom"
        placeholder="Donnez un nom explicite à votre déclaration d'activité"
        errorMessages={{ required: { message: 'Le nom est obligatoire' } }}
      />
    </SmoothLinkTarget>

    <SmoothLinkTarget
      name="userrequest.properties.description"
    >
      <TextArea
        model=".description"
        label="Description"
        placeholder="Décrivez au maximum en quoi consistera la ou les activités organisée(s)"
        errorMessages={{
          required: { message: 'La description est obligatoire' },
          lengthMax: { message: '1500 caractères maximum', rule: val => !val || val.length <= 1500 },
        }}
      />
    </SmoothLinkTarget>
  </Fieldset>
);
export default FormMain;



// WEBPACK FOOTER //
// ./src/components/Form/FormMain.js